import { getFooterData } from '@/shared/services/footer';
import type { FooterData } from '@/shared/types/footer';
import { useEffect, useState } from 'react';

export const useFooterData = () => {
  const [footerData, setFooterData] = useState<FooterData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFooterData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await getFooterData();

        if (response.status === 'success' && response.data) {
          setFooterData(response.data);
        } else {
          throw new Error(response.message || 'Failed to fetch footer data');
        }
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : 'Failed to fetch footer data';
        setError(errorMessage);
        console.error('Footer data fetch error:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFooterData();
  }, []);

  return {
    footerData,
    isLoading,
    error,
  };
};
